<template>
  <div :id="modalId" class="modal fade" role="dialog" aria-hidden="true">
    <AppDialog :modal-id="modalId" :open="open" content-class="app-dialog-content--lg" @update:open="handleOpenChange">
      <template #default>
        <div class="vm-detail-modal-content vm-detail-modal-content--viewport">
          <div class="modal-header vm-detail-panel-header">
            <div>
              <p class="vm-detail-panel-eyebrow">VM Image</p>
              <h4 class="modal-title vm-detail-panel-title">{{ title }}</h4>
            </div>
            <button type="button" class="vm-detail-close-button" aria-label="Close" @click="$emit('close')">
              <AppIcon name="close" aria-hidden="true" />
            </button>
          </div>
          <div class="modal-body" v-if="detailData">
            <table class="table table-bordered table-condensed vm-detail-table">
              <tbody>
                <tr v-for="(row, index) in detailData.rows" :key="`row-${index}`">
                  <th><div class="text-center">{{ row.label }}</div></th>
                  <td><div class="text-center">{{ row.value }}</div></td>
                </tr>
                <tr>
                  <th><div class="text-center">Referenced By</div></th>
                  <td>
                    <template v-if="detailData.referenced_vms && detailData.referenced_vms.length">
                      <div class="vm-image-reference-list">
                        <div
                          v-for="(vm, index) in detailData.referenced_vms"
                          :key="`ref-${index}`"
                          class="vm-image-reference-item"
                        >
                          <div class="vm-image-reference-main">
                            <strong>{{ vm.name }}</strong>
                            <span class="vm-image-reference-owner">{{ vm.owner }}</span>
                          </div>
                          <span class="vm-image-reference-status" :class="vm.state_class">{{ vm.state_label }}</span>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-center">Not used by any VM.</div>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </AppDialog>
  </div>
</template>

<script setup>
import AppDialog from './AppDialog.vue'
import AppIcon from './AppIcon.vue'

const props = defineProps({
  modalId: {
    type: String,
    required: true
  },
  open: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  detailData: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close'])

function handleOpenChange(nextOpen) {
  if (nextOpen) {
    return
  }

  emit('close')
}
</script>
